export default __webpack_public_path__ + "static/media/img-600x400-ResidenceYassin.939f0127.jpg";